var render, staticRenderFns
import script from "./WithFetch.vue?vue&type=script&lang=tsx"
export * from "./WithFetch.vue?vue&type=script&lang=tsx"
import style0 from "./WithFetch.vue?vue&type=style&index=0&id=4845ff48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845ff48",
  null
  
)

export default component.exports